// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-time-picker-custom .v-picker__title[data-v-0812026d] {\n  height: 84px;\n  padding-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
